export const mergeValuesIntoCards = (cardsArray, valueMap) => {
  const newCards = JSON.parse(JSON.stringify(cardsArray));
  newCards.forEach((card) => {
    card.items.forEach((item) => {
      if (item.item_type === 'field') {
        const defaultValueByType = {
          number: 0,
          checkbox: false,
          dropdown: '',
          multiselect: ''
        };
        const defaultValue = defaultValueByType[item.field.field_type] ?? '';
        const val = valueMap[item.field_id] ?? defaultValue;
        item.field_value = val;
      }
    });
  });
  return newCards;
};
